import { render, staticRenderFns } from "./StudentVouchers.vue?vue&type=template&id=0c3278ac"
import script from "./StudentVouchers.vue?vue&type=script&lang=ts"
export * from "./StudentVouchers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports